import React from 'react';
import cn from 'classnames';
import { VIDEO_CONFERENCE_TYPES, routes } from 'constants/config';
import Button from 'ui/Button';

const JoinVideoMeetingButton = ({ rsvpStatus, className, session, event }) => {
  // Fix camelCase issues. Eventually when all of InPersonTraining sends proper
  // casing we can remove this.
  const videoMeeting = session.videoMeeting || session.video_meeting;
  if (!videoMeeting || !rsvpStatus || rsvpStatus !== 'will_attend') return null;

  const joinMeetingClassName = cn(
    {
      'NewButton--zoomColor':
        videoMeeting.provider === VIDEO_CONFERENCE_TYPES.ZOOM,
    },
    className,
  );

  const getVideoMeetingUrl = () => {
    if (videoMeeting.provider !== VIDEO_CONFERENCE_TYPES.ZOOM) {
      return routes.IN_PERSON_TRAINING.JOIN_MEETING(event.id, session.id);
    }
    return videoMeeting.url;
  };

  return (
    <Button
      customColor={videoMeeting.provider !== VIDEO_CONFERENCE_TYPES.ZOOM}
      primary={videoMeeting.provider === VIDEO_CONFERENCE_TYPES.ZOOM}
      className={joinMeetingClassName}
      url={getVideoMeetingUrl()}
      rel="noopener noreferrer"
      target="_blank"
    >
      {videoMeeting.provider === VIDEO_CONFERENCE_TYPES.ZOOM
        ? t('in_person_training.event_overview.join_zoom_meeting')
        : t('in_person_training.event_overview.join_meeting')}
    </Button>
  );
};

export default JoinVideoMeetingButton;
